import React, { useState, useEffect } from "react";
import "./FacultyPrograms.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const FacultyPrograms = () => {
  const years = ["2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20"];

  const yearData = {
    "2024-25": {
      title: "Revolutionizing Healthcare: Integrating AI for Effective Solutions",
      duration: "5 Days",
      dates: "January 6 – 10, 2025",
      audience: "Faculty Members",
      mode: "Hybrid",
      overview1: "The FDP focused on fostering innovation and expertise in healthcare technology through AI tools like MATLAB. The program included expert sessions, hands-on workshops, and discussions on real-world healthcare challenges and solutions.",
      sessions: [
        {
          dayTitle: "Day 1: AI in Healthcare & Molecular Structures Analysis",
          points: [
            "Molecular structures for disease prediction",
            "AI's role in healthcare advancements and ethical considerations"
          ],
        },
        {
          dayTitle: "Day 2-3: Deep Learning with MATLAB",
          points: [
            "Image and audio processing using MATLAB",
            "Bounding boxes and advanced feature extraction",
            "Hands-on experience on deep learning applications"
          ],
        },
        {
          dayTitle: "Day 4: Machine Learning in Everyday Life",
          points: [
            "Automation applications across industries",
            "Improving efficiency through machine learning"
          ],
        },
        {
          dayTitle: "Day 5: Healthcare Innovation & Valedictory",
          points: [
            "Keynote address on healthcare innovation",
            "Faculty presentations and Valedictory Function"
          ],
        },
      ],
      tools: ["MATLAB", "DEEP LEARNING", "AI/ML", "HEALTHCARE", "IMAGE PROCESSING"],
      outcome: "Faculty gained insights, enhanced skills, and explored AI-enabled solutions to real-world healthcare challenges.",
    },
    "2023-24": {
      title: "Microsoft Power BI Workshop",
      duration: "2 Days",
      dates: "17 – 18 January, 2024",
      audience: "Faculty Members",
      mode: "Offline",
      overview1: "TIMSCDR organized a Faculty Development Program on Microsoft Power BI to equip faculty with practical business intelligence and dashboarding skills.",
      sessions: [
        {
          dayTitle: "Day 1: Data Modelling & Visualization",
          points: ["Data importation and transformation.", "Dashboard creation and report building."],
        },
        {
          dayTitle: "Day 2: Advanced Power BI Techniques",
          points: ["Intermediate DAX functions.", "Publishing and collaboration workflows."],
        },
      ],
      tools: ["POWER BI", "DAX", "DATA MODELLING", "DASHBOARDS"],
      outcome: "Faculty members learned to build, publish, and interpret professional business intelligence dashboards using Power BI.",
    },
    // ... Additional year data structure can follow the exact same format
  };

  // Timeline data for the sidebar matching the image
  const timelineData = [
    {
      year: "2023-24",
      title: "Microsoft Power BI Workshop",
      desc: "Two-day FDP on Microsoft Power BI in association with Computer Society of India.",
      iconPath: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM12 11v6m-3-3h6"
    },
    {
      year: "2022-23",
      title: "Robotic Process Automation",
      desc: "Two-day FDP on RPA using UiPath in association with FOSLIPY.",
      iconPath: "M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
    },
    {
      year: "2021-22",
      title: "Ruby Technology",
      desc: "One-day online FDP on Ruby Technology in association with Spoken Tutorial, IIT Bombay.",
      iconPath: "M20.24 12.24a5 5 0 0 0-8.49-3.49l-1.5 1.5M3.76 11.76a5 5 0 0 0 8.49 3.49l1.5-1.5"
    },
    {
      year: "2020-21",
      title: "Blockchain & Advanced Java",
      desc: "Two-day FDP on Blockchain & Advanced Java in association with CSI Mumbai Chapter & IIC.",
      iconPath: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    }
  ];

  // Carousel Image Array based on the uploaded image directory
  const carouselImages = [
    "/FDP/imgi_3_WhatsApp-Image-2025-01-09-at-1.43.26-PM.webp",
    "/FDP/imgi_4_1736509782303-1-1-scaled.webp",
    "/FDP/imgi_5_1736509781981-scaled.webp",
    "/FDP/imgi_6_1736509781739-scaled.webp",
    "/FDP/imgi_7_FDP-23-scaled.webp",
    "/FDP/imgi_8_FDP_24-scaled.webp",
    "/FDP/imgi_9_FDP_23-scaled.webp",
    "/FDP/imgi_10_FDP2023.webp",
    "/FDP/imgi_11_FDP-Day-1.webp",
    "/FDP/imgi_12_FDP-Day-1-1.webp",
    "/FDP/imgi_13_FDP-Day-2.webp",
    "/FDP/imgi_14_FDP-2021-New.webp",
    "/FDP/imgi_15_FDP-2021-New1.webp",
    "/FDP/imgi_16_01-FDP-blockchain-2021-copy.webp",
    "/FDP/imgi_17_02-FDP-blockchain-2021-copy.webp",
    "/FDP/imgi_18_07-FDP-blockchain-2021-copy.webp",
    "/FDP/imgi_19_08-FDP-blockchain-2021-copy.webp",
    "/FDP/imgi_20_01-FDP-Machine-Learning-with-R-2019.webp",
    "/FDP/imgi_21_02-FDP-Machine-Learning-with-R-2019.webp",
    "/FDP/imgi_22_03-FDP-Machine-Learning-with-R-2019.webp",
    "/FDP/imgi_23_04-FDP-Machine-Learning-with-R-2019.webp",
    "/FDP/imgi_24_05-01-Python-Workshop-December-2018.webp",
    "/FDP/imgi_25_06-02-Python-Workshop-December-2018.webp"
  ];

  const [activeYear, setActiveYear] = useState("2024-25");
  const [currentSlide, setCurrentSlide] = useState(0);

  // Default to 2024-25 if data for clicked year is missing in the abbreviated object
  const current = yearData[activeYear] || yearData["2024-25"];

  // Carousel Auto-play logic
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500); // Change image every 3.5 seconds

    return () => clearInterval(slideInterval);
  }, [carouselImages.length]);

  return (
    <>
      <Navbar />
      <PageHeader
        title="Faculty Development Programmes (FDPs)"
        crumbs={[
          { label: 'Home', href: '/' },
          { label: 'FDP', href: '/faculty-development-programs' }
        ]}
      />
      
      <div className="fdp-page-root">
        <div className="fdp-page-container">

          {/* HERO SECTION */}
          <div className="fdp-hero-wrapper">
            <div className="fdp-hero-left">
              <div className="fdp-hero-text">
                Our Faculty Development Programmes (FDPs) are designed to enhance the knowledge and skills
                of our faculty members in alignment with the latest advancements in the MCA syllabus of
                Mumbai University. These FDPs cover a wide range of topics, ensuring our educators are
                well-equipped to provide high-quality education to students pursuing their MCA degrees.
              </div>

              <div className="fdp-stats-container">
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">05+</span>
                    <span className="fdp-stat-label">FDPs Conducted</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">2019-25</span>
                    <span className="fdp-stat-label">Academic Years</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">100+</span>
                    <span className="fdp-stat-label">Faculty Members Benefited</span>
                  </div>
                </div>
                <div className="fdp-stat-item">
                  <div className="fdp-stat-icon-wrapper">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
                  </div>
                  <div className="fdp-stat-content">
                    <span className="fdp-stat-value">Industry Relevant</span>
                    <span className="fdp-stat-label">Skills & Technologies</span>
                  </div>
                </div>
              </div>
            </div>

            {/* REPLACED ILLUSTRATION WITH IMAGE CAROUSEL */}
            <div className="fdp-hero-right">
              <div 
                className="fdp-hero-carousel" 
                style={{ 
                  position: 'relative', 
                  width: '100%', 
                  height: '350px', // Adjust height as necessary to match your layout
                  borderRadius: '16px', 
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.15)',
                  backgroundColor: '#f1f5f9'
                }}
              >
                {carouselImages.map((imgSrc, idx) => (
                  <img 
                    key={idx}
                    src={imgSrc} 
                    alt={`FDP Highlight ${idx + 1}`}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // Ensures the image fills the area gracefully without stretching
                      opacity: currentSlide === idx ? 1 : 0,
                      transition: 'opacity 0.8s ease-in-out',
                      zIndex: currentSlide === idx ? 1 : 0
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* YEAR TABS */}
          <div className="fdp-year-nav">
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={
                  activeYear === year
                    ? "fdp-year-btn fdp-year-btn-active"
                    : "fdp-year-btn"
                }
                onClick={() => setActiveYear(year)}
              >
                {year}
              </button>
            ))}
          </div>

          {/* MAIN CONTENT & SIDEBAR */}
          <div className="fdp-main-grid">

            {/* Left Main Card */}
            <div className="fdp-main-card">
              <div className="fdp-main-title">{current.title}</div>

              {/* Meta info tags */}
              <div className="fdp-meta-grid">
                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Duration:</span>
                  <span className="fdp-meta-value">{current.duration}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Date:</span>
                  <span className="fdp-meta-value">{current.dates}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Audience:</span>
                  <span className="fdp-meta-value">{current.audience}</span>
                </div>

                <div className="fdp-meta-item">
                  <span className="fdp-meta-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
                  </span>
                  <span className="fdp-meta-label">Mode:</span>
                  <span className="fdp-meta-value">{current.mode}</span>
                </div>
              </div>

              {/* Overview */}
              <div className="fdp-section">
                <div className="fdp-section-title">Overview</div>
                <div className="fdp-section-text">{current.overview1}</div>
                {current.overview2 && <div className="fdp-section-text">{current.overview2}</div>}
              </div>

              {/* Sessions */}
              <div className="fdp-section">
                <div className="fdp-section-title">Key Sessions / Topics Covered</div>
                <div className="fdp-session-list">
                  {current.sessions.map((session, idx) => (
                    <div key={idx} className="fdp-session-block">
                      <div className="fdp-session-day-title">
                        {session.dayTitle}
                      </div>
                      <ul className="fdp-session-ul">
                        {session.points.map((pt, i) => (
                          <li key={i} className="fdp-session-li">
                            {pt}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tools */}
              <div className="fdp-section">
                <div className="fdp-section-title">Tools & Technologies Used</div>
                <div className="fdp-tools-row">
                  {current.tools.map((tool) => (
                    <span key={tool} className="fdp-tool-chip">
                      {tool}
                    </span>
                  ))}
                </div>
              </div>

              {/* Outcome */}
              <div className="fdp-outcome-box">
                <div className="fdp-outcome-text">
                  {current.outcome}
                </div>
              </div>
            </div>

            {/* Right Sidebar Timeline */}
            <div className="fdp-timeline-sidebar">
              <div className="fdp-timeline">
                {timelineData.map((item, index) => (
                  <div key={index} className="fdp-timeline-item">
                    <div className="fdp-timeline-icon">
                      <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d={item.iconPath}></path>
                      </svg>
                    </div>
                    <div className="fdp-timeline-content">
                      <div className="fdp-timeline-year">{item.year}</div>
                      <div className="fdp-timeline-title">{item.title}</div>
                      <div className="fdp-timeline-desc">{item.desc}</div>
                      <button className="fdp-view-details" onClick={() => setActiveYear(item.year)}>
                        View Details
                        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                          <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FacultyPrograms;